import { Globals } from "@coreapp/CoreApp/Globals";
import { enumFieldType } from "@coreapp/constants";

export const useFieldProperties = ({ fieldDef }) => {
  const fieldType = fieldDef.GetFieldType();
  const fieldSubType = fieldDef.GetFieldSubtype();
  const showThousandsSep = fieldDef.GetShowThousandsSep();
  const thousandSeparator = showThousandsSep ? Globals._thousandSeparator : false;
  const isNumericValue = fieldType === enumFieldType.number;
  const showPercentage = fieldDef.GetShowPercent();
  const prefix = fieldDef.GetPrefix() ?? "";
  const suffix = fieldDef.GetPostfix() ?? "";
  const decimalScale = fieldDef.GetNumDecPlaces() ?? 0;
  const dateFormat = fieldDef.GetDateFormat();
  const doConvertToLocal = fieldDef.GetShowLocal();

  return {
    fieldType,
    fieldSubType,
    thousandSeparator,
    isNumericValue,
    showPercentage,
    decimalScale,
    dateFormat,
    doConvertToLocal,
    prefix,
    suffix
  };
};
